import  { useState, useEffect, useRef } from "react";
import "./style.css";
import { useHistory } from "react-router-dom";
import moment from "moment";

import { makeStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import IconButton from "@mui/material/IconButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CircularProgress from "@mui/material/CircularProgress";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import EmojiFoodBeverageIcon from "@mui/icons-material/EmojiFoodBeverage";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import { Alert } from "@mui/material";

import LinearProgress from "@mui/material/LinearProgress";

import FormLabel from "@mui/material/FormLabel";
import constants from "util/constants";
import SingleAddressField from "components/AddressField/SingleAddressField";

import clsx from "clsx";

import { Card, CardContent, Divider, Grid, TextField } from "@mui/material";

import { useSelector, useDispatch } from "react-redux";
import {
  setRestaurantId,
  emptyCart,
  saveUser,
  loadUser,
  updateTillPaymentUrl,
  updateAdyen,
  updateDeliveryQuotes,
} from "store/actions/order";


import { usePosition } from "use-position";

import { mobileModel, browserName, browserVersion } from "react-device-detect";

import {
  loadTableId,
  checkMobilePhone,
  checkNumber,
  loadRestaurant
} from "util/orderUtils";

import { loadStripe } from "@stripe/stripe-js/pure";

import CallButton from "../Online/components/CallButton";
import Payments from "./Payments";
import OrderDateTime from "./OrderDateTime";

import { filterOpenHours, decodeRestaurantId, noWheelInputProps } from "util/utils";
import {
  isOrderInRestaurant,
  isTakeaway,
  isDelivery,
  isPickup,
  isPickupOrDelivery,
  isFoodcourt,
} from "util/restaurantUtils";
import { showErrorSnackbar } from "store/actions/snackbarMessage";
import analytics from "common/analytics";
import { logError } from "apis/utilAPIs";
import API from "util/API";
import { Turnstile } from "@marsidev/react-turnstile";

// const turnstileSiteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY;
// console.log('turnstileSiteKey', turnstileSiteKey);
const turnstileSiteKey = null;
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: '100vh',
    position: 'relative',
    paddingBottom: '80px', // Space for fixed button
  },
  content: {
    padding: theme.spacing(1.5),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    size: 12,
  },

  leftMargin: {
    marginLeft: theme.spacing(2),
  },

  formTitle: {
    flexGrow: 1,
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },

  formContent: {
    flexGrow: 1,
    margin: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  item: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  stickToBottom: {
    width: "100%",
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1100,
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
    padding: theme.spacing(2),
    paddingBottom: `calc(${theme.spacing(2)} + env(safe-area-inset-bottom, 0px))`,
  },
  progress: {
    position: "absolute",
  },
  compactCard: {
    marginBottom: theme.spacing(1.5),
  },
  sectionTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
  },
}));
const Checkout = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isSubmittingRef = useRef(false);
  const turnstileRef = useRef(null);

  const [name, setName] = useState("");
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [email, setEmail] = useState("");
  const [guestNum, setGuestNum] = useState("");
  const [address, setAddress] = useState("");
  const [addressObject, setAddressObject] = useState(null);
  const [pickupTimeType, setPickupTimeType] = useState("now");
  const [pickupTime, setPickupTime] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [verifyCode, setVerifyCode] = useState("");
  const [verifyCodeError, setVerifyCodeError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [postcode, setPostcode] = useState("");
  const [notes] = useState("");
  const [sid, setSid] = useState("");
  const [foodAllergies] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const [checkLoading, setCheckLoading] = useState(false);
  const [deliveryQuotes, setDeliveryQuotes] = useState(null);
  const [deliveryFee, setDeliveryFee] = useState(null);
  const [hasDeliveryFee, setHasDeliveryFee] = useState(false);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [realTableId, setRealTableId] = useState(null);
  const [chooseType, setChooseType] = useState("pickup");

  const updateRestaurantId = (restaurantId) =>
    dispatch(setRestaurantId(restaurantId));
  const showError = (msg) => dispatch(showErrorSnackbar(msg));

  const history = useHistory();
  const [successLink, setSuccessLink] = useState("/orderSuccess");
  const updateUser = (user) => dispatch(saveUser(user));
  const loadSavedUser = () => dispatch(loadUser());
  const updateTillPayUrl = (url) => dispatch(updateTillPaymentUrl(url));
  const updateAdyenSession = (data) => dispatch(updateAdyen(data));
  const updateDeliveryQuotesAction = (quotes) => dispatch(updateDeliveryQuotes(quotes));
  const menuTableId = useSelector((state) => state.menu.tableId);
  const reduxRestaurant = useSelector((state) => state.menu.restaurant);
  const [localRestaurant, setLocalRestaurant] = useState(null);
  const restaurant = reduxRestaurant || localRestaurant;
  const memberId = useSelector((state) => state.order.memberId);

  const goBack = (e) => {
    props.history.goBack();
  };
  const order = useSelector((state) => state.order);
  const savedUser = useSelector((state) => state.order.user);

  const id = props.match.params.menuId;
  const tableId = props.match.params.tableId;

  const watch = true;
  const { latitude, longitude, timestamp, accuracy, error } = usePosition(
    watch,
    { enableHighAccuracy: true }
  );

  useEffect(() => {
    loadSavedUser();
    const formattedTime = moment(Date()).format("HH:mm");
    setPickupTime(formattedTime);

    // Cleanup function to reset submission state on unmount
    return () => {
      isSubmittingRef.current = false;
    };
  }, [props]);

  useEffect(() => {
    if (!restaurant) {
       const loaded = loadRestaurant(decodeRestaurantId(id));
       if (loaded) {
         setLocalRestaurant(loaded);
       }
    }
  }, [restaurant]);

  useEffect(() => {
    if (savedUser) {
      setName(savedUser.name);
      if (savedUser.email) {
        setEmail(savedUser.email);
      }
      
      setPhoneNumber(savedUser.phoneNumber ? savedUser.phoneNumber : "");
      setGuestNum(savedUser.guestNum ? savedUser.guestNum : "");
      if (savedUser.address) {
      setAddress(savedUser.address);
      }
    }
  }, [savedUser]);

  useEffect(() => {
    const successLinkTarget = `/orderSuccess/${id}/${tableId}`;
    //console.log('successLinkTarget', successLinkTarget);
    setSuccessLink(successLinkTarget);

    if (order.cart.length === 0 && id && tableId) {
      updateRestaurantId({
        restaurantId: decodeRestaurantId(id),
        tableId: tableId,
      });
    }
    setSelectedDate(Date());

    //console.log('menuTableId', realTableId, id, menuTableId);
    setupTableId();
  }, [props]);

  const setupTableId = () => {
    if (!menuTableId) {
      setRealTableId(loadTableId(decodeRestaurantId(id)));
      // console.log('realTableId get', realTableId, id);
    } else {
      setRealTableId(menuTableId);
    }
  };

  const isQRCodePaymentNeed = () => {
    if (restaurant && restaurant.qrCodeSettings &&
      (restaurant.qrCodeSettings.payment === 'required' ||
      restaurant.qrCodeSettings.payment === 'optional')) {
      return true;
    }
    return false;
  };

  const isQRCodePaymentRequired = () => {
    if (restaurant && restaurant.qrCodeSettings &&
      restaurant.qrCodeSettings.payment === 'required') {
      return true;
    }
    return false;
  };

  const isQRCodePaymentOptional = () => {
    if (restaurant && restaurant.qrCodeSettings &&
      restaurant.qrCodeSettings.payment === 'optional') {
      return true;
    }
    return false;
  };

  const isDineRequired = () => {
    //console.log('realTableId', realTableId);
    return (
      String(realTableId).split(";").length === 2 &&
      String(realTableId).split(";")[1] === "required") || 
      isQRCodePaymentRequired()
    ;
  };

  function isPositiveInteger(n) {
    return n >>> 0 === parseFloat(n);
  }

  const isGuestNumberShown = () => {
    if (
      isOrderInRestaurant(realTableId) &&
      restaurant &&
      restaurant.onlineSettings &&
      restaurant.onlineSettings.isDineInGuestNumberRequired &&
      restaurant.onlineSettings.isDineInGuestNumberRequired === true
    ) {
      return true;
    }
    return false;
  };

  const isNameHidden = () => {
    return (
      isOrderInRestaurant(realTableId) &&
      restaurant &&
      restaurant.onlineSettings &&
      restaurant.onlineSettings.isDineInNameHidden === true
    );
  };

  const isMobileNumbeHidden = () => {
    if (
      isOrderInRestaurant(realTableId) &&
      (!restaurant ||
        !restaurant.onlineSettings ||
        !restaurant.onlineSettings.isDineInMobilePhoneRequired)
    ) {
      return true;
    }
    return false;
  };

  const needCheckGuestNum = () => {
    // console.log('isDineMobileAndGuestNumberOptional()', isDineMobileAndGuestNumberOptional());
    if (!isGuestNumberShown()) {
      // console.log("not dine in");
      return false;
    }

    if (isDineMobileAndGuestNumberOptional()) {
      return false;
    }

    if (guestNum.trim() === "") {
      return true;
    }

    const num = Number(guestNum);
    if (!isPositiveInteger(num) || num < 1 || num > 50) {
      return true;
    }

    return false;
  };

  const getGuestNumError = () => {
    if (!isGuestNumberShown()) return "";
    if (isDineMobileAndGuestNumberOptional() && guestNum.trim() === "") return "";
    if (guestNum.trim() === "") return "";
    const num = Number(guestNum);
    if (!isPositiveInteger(num) || num < 1) return "Please enter at least 1 guest";
    if (num > 50) return "Maximum 50 guests allowed";
    return "";
  };

  const needCheckAddress = () => {
    if (
      isDelivery(realTableId) ||
      (isPickupOrDelivery(realTableId) && chooseType === "delivery")
    ) {
      return !address;
    } else {
      return false;
    }
  };


  
  const isDeliveryContext = () => {
    return (
      isDelivery(realTableId) ||
      (isPickupOrDelivery(realTableId) && chooseType === "delivery")
    );
  };

  const isDeliveryCashAvailable = () => {
    return (
      isDeliveryContext() &&
      restaurant &&
      restaurant.onlineSettings &&
      restaurant.onlineSettings.isDeliveryCashPaymentEnabled === true
    );
  };

  const isDeliveryTimeHidden = () => {
    return (
      restaurant &&
      restaurant.onlineSettings &&
      restaurant.onlineSettings.hideDeliveryTime === true
    );
  };

  const isPaymentRequired = () => {
    if (order.paymentType === "cash" && isDeliveryCashAvailable()) {
      return false;
    }
    return (
      isDelivery(realTableId) ||
      isPickup(realTableId) ||
      isPickupOrDelivery(realTableId) ||
      isDineRequired() ||
      (isFoodcourt(realTableId) &&
        restaurant &&
        restaurant.onlineSettings &&
        restaurant.onlineSettings.foodCourtPaymentRequired === true) ||
      isQRCodePaymentRequired()
    );
  };

  const needCheckPayment = () => {
    return (
      isPaymentRequired() &&
      (!order.paymentType || order.paymentType.trim() === "")
    );
  };

  const needCheckDateTime = () => {
    // console.log('selectedDate', pickupTimeType, pickupTime.trim(), selectedDate, !selectedDate);
    if (pickupTimeType === "now" || isOrderInRestaurant(realTableId)) {
      return false;
    }
    if (pickupTime.trim() === "" || !selectedDate) {
      return true;
    }
    return false;
  };

  const showTakeawayPayment = () => {
    //console.log('restaurant', restaurant);
    return (
      isTakeaway(realTableId) &&
      restaurant &&
      (restaurant.takeawayPayment === undefined ||
        restaurant.takeawayPayment === true)
    );
  };

  const showFoodcourtPayment = () => {
    //console.log('restaurant', restaurant);
    return (
      isFoodcourt(realTableId) &&
      restaurant &&
      restaurant.onlineSettings &&
      restaurant.onlineSettings.foodCourtPaymentOptional === true
    );
  };

  const handleTypeChange = (event) => {
    setChooseType(event.target.value);
  };

  const getOrderFoodTime = () => {
    if (pickupTimeType === "now") {
      return moment(new Date());
    }

    const selectedDateStr = moment(selectedDate).format("DD/MM/YYYY");
    return moment(`${selectedDateStr} ${pickupTime}`, "DD/MM/YYYY HH:mm");
  };

  const isDineMobileAndGuestNumberOptional = () => {
    return (
      isOrderInRestaurant(realTableId) &&
      restaurant &&
      restaurant.isDineMobileOptional === true
    );
  };

  const isMobileNumberNotValid = () => {
    if (isMobileNumbeHidden()) {
      return false;
    }
    if (
      isOrderInRestaurant(realTableId) &&
      isDineMobileAndGuestNumberOptional() &&
      phoneNumber === ""
    ) {
      return false;
    }

    return !checkMobilePhone(phoneNumber);
  };

  const checkOpenHours = () => {
    if (restaurant && restaurant.openHours) {
      const orderTime = getOrderFoodTime();
      // console.log(orderTime);
      return filterOpenHours(restaurant.openHours, orderTime);
    }

    return true;
  };

  const updatePhoneNumber = (mobilePhone) => {
    setPhoneNumber(mobilePhone);
    if (!checkMobilePhone(mobilePhone)) {
      setPhoneNumberError("The mobile number is invalid");
    } else {
      setPhoneNumberError("");
    }
  };

  const updateVerifyCode = (code) => {
    setVerifyCode(code);
    if (!checkNumber(code)) {
      setVerifyCodeError("The code is invalid");
    } else {
      setVerifyCodeError("");
    }
  };

  const showErrorMessage = () => {
    showError("Something went wrong! Please try again.");
  };

  const isPostcodeRequired = () => {
    return (
      (isDelivery(realTableId) || isPickupOrDelivery(realTableId)) &&
      postcode === ""
    );
  };

  const isVerifyCodeValid = () => {
    if (restaurant && restaurant.smsVerify === true) {
      if (verifyCode.trim() === "" || checkNumber(verifyCode) === false) {
        return false;
      }
    }
    return true;
  };

  const sendVerifyCode = async () => {
    if (!checkMobilePhone(phoneNumber)) {
      showError("Please enter a valid mobile phone number");
      return;
    }

    // Prevent duplicate SMS requests
    if (checkLoading) {
      return;
    }

    const token = turnstileToken || turnstileRef.current?.getResponse();
    if (!token) {
      showError("Please complete the verification challenge.");
      return;
    }

    setCheckLoading(true);

    try {
      const response = await API.post("/sendCode", {
        mobilePhone: phoneNumber,
        turnstileToken: token,
        restaurantId: order.restaurant.restaurantId,
      });
      if (response && response.data && response.data.sid) {
        setSid(response.data.sid);
      }
      setCheckLoading(false);
    } catch (err) {
      setCheckLoading(false);
      showError("Something went wrong! Please try again.");

      const errorData = {
        title: "sendVerifyCode Error",
        message: err.response
          ? JSON.stringify(err.response.data)
          : err.message,
      };
      logError(errorData);
    }
  };

  const getCurrencySymbol = () => {
    if (restaurant && restaurant.currencySymbol) {
      return restaurant.currencySymbol;
    }
    return '$';
  };

  const getDeliveryFee = () => {
    if (
      (isDelivery(realTableId) || (isPickupOrDelivery(realTableId) && chooseType === "delivery")) &&
      deliveryQuotes &&
      deliveryQuotes.length > 0
    ) {
      // Get the first quote as specified in the requirements
      const firstQuote = deliveryQuotes[0];
      return {
        name: `Delivery Fee (${firstQuote.providerName})`,
        type: "delivery",
        amount: (firstQuote.priceCents / 100).toFixed(2), // Convert cents to dollars
        providerName: firstQuote.providerName,
        providerLogo: firstQuote.providerLogo,
        dropoffEta: firstQuote.dropoffEta,
        currency: firstQuote.currency,
      };
    }
    return deliveryFee;
  };

  const getServiceFee = (cartItemTotal, deliveryFeeAmount) => {
    if (
      restaurant &&
      restaurant.isDeliveryServiceEnabled === true &&
      hasDeliveryFee &&
      restaurant.deliveryServiceOnlineRate
    ) {
      const serviceFeeAmount = ((cartItemTotal + deliveryFeeAmount) * restaurant.deliveryServiceOnlineRate) / 100;
      return {
        name: "Service Fee",
        type: "service",
        amount: serviceFeeAmount.toFixed(2),
      };
    }
    return null;
  };

  const getSurcharges = (cartItemTotal) => {
    let surcharges = [];
    
    // Add holiday surcharge
    if (
      restaurant &&
      restaurant.holidaySurcharge &&
      restaurant.holidaySurcharge.isEnabled === true
    ) {
      let holidaySurcharge = 0;
      if (restaurant.holidaySurcharge.isPercentage === true) {
        const percents = Number(restaurant.holidaySurcharge.amount);
        holidaySurcharge = (cartItemTotal * percents) / 100;
      } else {
        holidaySurcharge = Number(restaurant.holidaySurcharge.amount);
      }

      surcharges.push({
        name: restaurant.holidaySurcharge.name,
        type: "holiday",
        amount: holidaySurcharge.toFixed(2),
      });
    }

    // Add service fee if delivery service is enabled and delivery fee is available
    const currentDeliveryFee = getDeliveryFee();
    const deliveryFeeAmount = currentDeliveryFee ? parseFloat(currentDeliveryFee.amount) : 0;
    const serviceFeeItem = getServiceFee(cartItemTotal, deliveryFeeAmount);
    if (serviceFeeItem) {
      surcharges.push(serviceFeeItem);
    }

    return surcharges;
  };

  const emptyOrderCart = (formRequest, response) => {
    dispatch(
      emptyCart({
        ...formRequest.order,
        id: response.data.reference,
      })
    );
  };

  const handleResponse = async (formRequest, response) => {
    setButtonLoading(false);
    isSubmittingRef.current = false;
    // console.log('response', JSON.stringify(response.data, null, 2));

    // Store delivery quotes if present in response
    if (response.data && response.data.delivery && response.data.delivery.quotes) {
      setDeliveryQuotes(response.data.delivery.quotes);
      updateDeliveryQuotesAction(response.data.delivery.quotes);
      
      // Set delivery fee and mark as having delivery fee
      const firstQuote = response.data.delivery.quotes[0];
      const deliveryFeeData = {
        name: `Delivery Fee (${firstQuote.providerName})`,
        type: "delivery",
        amount: (firstQuote.priceCents / 100).toFixed(2),
        providerName: firstQuote.providerName,
        providerLogo: firstQuote.providerLogo,
        dropoffEta: firstQuote.dropoffEta,
        currency: firstQuote.currency,
      };
      setDeliveryFee(deliveryFeeData);
      setHasDeliveryFee(true);
      return;
    }

    if(response.data && response.data.paymentUrl) {
      emptyOrderCart(formRequest, response);
      window.location.assign(response.data.paymentUrl);
      return;
    }

    // console.log("response.data", response.data);
    if (response && response.data && response.data.isAdyenPayment === true) {
      if (response.data.paymentMethodResults && response.data.paymentMethodResults) {
        updateAdyenSession({
          paymentMethodResults: response.data.paymentMethodResults,
          order: formRequest,
          environment: response.data.environment,
          clientKey: response.data.clientKey,
          orderNumber: response.data.reference,
          yearStr: response.data.yearStr,
          dateStr: response.data.dateStr,
          orderTotal: response.data.orderTotal,
          currency: response.data.currency,
          locale: response.data.locale,
          countryCode: response.data.countryCode,

        });
        // emptyOrderCart(formRequest, response);
        history.push(
          `/adyenPayment/${id}/${tableId}/${response.data.reference}`
        );

        return;
      }
    }

    if (response.data.sessionId) {
      const stripe = await loadStripe(import.meta.env.VITE_stripe_key, {
        stripeAccount: response.data.stripeAccount,
      });

      emptyOrderCart(formRequest, response);

      const result = await stripe.redirectToCheckout({
        sessionId: response.data.sessionId,
      });

      // console.log(result);

      if (result.error) {
        console.error(result.error);
        showErrorMessage();
        return;
      }
    } else {
      if (
        response.data.isTillPayment === true &&
        response.data.payUrl &&
        response.data.payUrl.trim().length > 0
      ) {
        emptyOrderCart(formRequest, response);
        updateTillPayUrl(response.data.payUrl);
        history.push(
          `/tillPayment/${id}/${tableId}/${response.data.reference}`
        );
        return;
      }
      if (response.data.payUrl && response.data.payUrl.trim().length > 0) {
        emptyOrderCart(formRequest, response);
        window.location.assign(response.data.payUrl);
      } else {
        emptyOrderCart(formRequest, response);
        history.push(`${successLink}/${response.data.reference}/local`);
      }
    }
  };

  const validateEmail = (checkEmail) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(checkEmail).toLowerCase());
  };

  const placeOrder = async (event) => {
    event.preventDefault();

    // Prevent duplicate submissions
    if (isSubmittingRef.current || buttonLoading) {
      return;
    }

    if (!checkOpenHours()) {
      showError(
        "The merchant is now not operating, Please order after opening."
      );
      return;
    }

    if (isPostcodeRequired()) {
      showError("Please enter a postcode.");
      return;
    }

    if (isMobileNumberNotValid()) {
      showError("Please enter a valid mobile phone number.");
      return;
    }

    // if (postcode.length === 0) {
    //   showError("Please enter a valid postcode.");
    //   return;
    // }

    if (needCheckPayment()) {
      showError("Please select a payment method.");
      return;
    }

    if(email !== "" && !validateEmail(email)) {
      showError("Please enter a valid email address.");
      return;
    }

    // Mark as submitting and set loading state
    isSubmittingRef.current = true;
    setButtonLoading(true);
    API.defaults.headers.common["restaurantId"] = order.restaurant.restaurantId;
      API.defaults.headers.common["menuId"] = id;
    API.defaults.headers.common["clientId"] = constants.CLIENT_ID;
      


    const cartItemTotal = order.cart.reduce((count, curItem) => {
      return count + curItem.quantity * curItem.subTotal;
    }, 0);

    // Calculate delivery fee if applicable
    const currentDeliveryFee = getDeliveryFee();
    const deliveryFeeAmount = currentDeliveryFee ? parseFloat(currentDeliveryFee.amount) : 0;
    
    // Calculate service fee if delivery service is enabled
    const serviceFeeItem = getServiceFee(cartItemTotal, deliveryFeeAmount);
    const serviceFeeAmount = serviceFeeItem ? parseFloat(serviceFeeItem.amount) : 0;

    /* Track a custom event */
    analytics.track("placeOrder", {
      price: cartItemTotal + deliveryFeeAmount + serviceFeeAmount,
      restaurantId: order.restaurant.realTableId,
    });

    const formRequest = {
      user: {
        name,
        email,
        phoneNumber,
        guestNum: guestNum.trim() === "" ? "0" : guestNum.trim(),
        address,
        addressObject,
        postcode,
        foodAllergies,
        geolocation: {
          latitude,
          longitude,
          timestamp,
          accuracy,
          error,
        },
      },
      order: {
        orderNumber: order.orderNumber,
        items: order.cart,
        pickupTimeType: pickupTimeType,
        pickupTime: pickupTime,
        selectedDate: moment(selectedDate).format("DD/MM/YYYY"),
        total: Number((cartItemTotal + deliveryFeeAmount + serviceFeeAmount).toFixed(2)),
        paymentType: order.paymentType
          ? order.paymentType
          : isPaymentRequired()
          ? "card"
          : "",
        isPaymentRequired: isPaymentRequired(),
        type: isOrderInRestaurant(realTableId) ? "dinein" : realTableId,
        realTableId,
        chooseType,
        notes,
        orderTime: moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
        surcharges: [
          ...getSurcharges(cartItemTotal),
          ...(currentDeliveryFee ? [currentDeliveryFee] : [])
        ],
      },
      restaurant: order.restaurant,
      menuId: id,
      browser: `${browserName} ${browserVersion}`,
      mobileModel: mobileModel,
      verifyCode,
      sid,
      memberId,
      deliveryQuoteId: deliveryQuotes && deliveryQuotes.length > 0 ? deliveryQuotes[0].id : null,
    };
    updateUser(formRequest.user);

    const cfToken = turnstileToken || turnstileRef.current?.getResponse();
    if (turnstileSiteKey && !cfToken) {
      showError("Please complete the verification challenge.");
      setButtonLoading(false);
      isSubmittingRef.current = false;
      return;
    }

    try {
      const response = await API.post("/placeOrder", {
        ...formRequest,
        turnstileToken: cfToken,
      });

      handleResponse(formRequest, response);
    } catch (err) {
      try {
        const info = {
          restaurantId: order.restaurant.restaurantId,
          tableId: realTableId,
          payload: formRequest,
          responseMessage:
            err.response && err.response.data
              ? JSON.stringify(err.response.data)
              : "",
          responseStatus:
            err.response && err.response.status
              ? err.response.status
              : "",
        };

        const errorData = {
          title: "Place Order Error",
          message: `${err.message}, info: ${JSON.stringify(info)}`,
        };

        logError(errorData);
        
        if (err.response && err.response.data) {
          const errorData = err.response.data;
          if (errorData.duplicate && errorData.duplicate === true) {
            handleResponse(formRequest, err.response);
            return;
          }
        }
        
        // Reset states on error
        setButtonLoading(false);
        isSubmittingRef.current = false;
        showErrorMessage();
      } catch (error) {
        console.error(error);
        setButtonLoading(false);
        isSubmittingRef.current = false;
        showErrorMessage();
      }
    }
  
  };



  const paybuttonLabel = () => {
    // Check if delivery service is enabled and we need to get delivery fee first
    if (
      restaurant &&
      restaurant.isDeliveryServiceEnabled === true &&
      (isDelivery(realTableId) || (isPickupOrDelivery(realTableId) && chooseType === "delivery")) &&
      !hasDeliveryFee
    ) {
      return "Get Delivery Fee";
    }
    
    if (isPaymentRequired() || order.paymentType === "card") {
      return "Place Order";
    } else if (order.paymentType === "cash") {
      return "Place Order · Pay Cash on Delivery";
    } else if (order.paymentType === "payAtCounter") {
      return "Pay At Counter";
    } else {
      const customTitle =
      isOrderInRestaurant(realTableId) &&
      restaurant?.onlineSettings?.dineinOnlinePayAtCounterCheckoutButtonTitle;
    return customTitle || "Place Order & Pay At Counter";
    }
  };

  const handleAddressChange = (newAddress) => {
    const addressString = `${newAddress.line1} ${newAddress.line2} ${newAddress.line3} ${newAddress.city} ${newAddress.stateOrProvince} ${newAddress.country} ${newAddress.postalCode}`;
    setAddress(addressString);
    setAddressObject(newAddress);
    setPostcode(newAddress.postalCode);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            onClick={goBack}
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
          >
            <ArrowBackIosIcon />
          </IconButton>
          <Grid alignItems="center" xs={12} container justify="center">
            <Grid item alignItems="center">
              <CallButton />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      {buttonLoading ? <LinearProgress /> : null}

      <Card className={clsx(classes.root, classes, classes.formContent)}>
        <form noValidate>
          <Divider />
          <CardContent sx={{ padding: '12px !important', paddingBottom: '12px !important' }}>
            <Grid container spacing={1.5}>
              {isNameHidden() ? null : (
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    label="Name (required)"
                    margin="none"
                    name="name"
                    variant="outlined"
                    size="small"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              )}
              {isGuestNumberShown() ? (
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    label={`Number of guests (${
                      isDineMobileAndGuestNumberOptional() === true
                        ? "Optional"
                        : "required"
                    })`}
                    margin="none"
                    name="guestNum"
                    type="number"
                    variant="outlined"
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{ ...noWheelInputProps, min: 1, max: 50 }}
                    value={guestNum}
                    onChange={(e) => setGuestNum(e.target.value)}
                    error={!!getGuestNumError()}
                    helperText={getGuestNumError()}
                  />
                </Grid>
              ) : null}

              {isPickupOrDelivery(realTableId) ? (
                <Grid item md={6} xs={12}>
                  <FormControl component="fieldset" fullWidth>
                    <FormLabel component="legend" sx={{ fontSize: '0.875rem', marginBottom: '4px' }}>
                      Choose pickup or delivery
                    </FormLabel>
                    <RadioGroup
                      value={chooseType}
                      aria-label="payment choice"
                      name="chooseType"
                      onChange={handleTypeChange}
                      sx={{ marginTop: '4px' }}
                    >
                      <FormControlLabel
                        value="pickup"
                        control={<Radio color="primary" size="small" />}
                        label={<Typography variant="body2">Pickup</Typography>}
                        sx={{ marginBottom: '-4px' }}
                      />
                      <FormControlLabel
                        value="delivery"
                        control={<Radio color="primary" size="small" />}
                        label={<Typography variant="body2">Delivery</Typography>}
                        sx={{ marginBottom: '-4px' }}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              ) : null}

              {isDelivery(realTableId) ||
              (isPickupOrDelivery(realTableId) && chooseType === "delivery") ? (
                <Grid item md={6} xs={12}>
                
                    <SingleAddressField onAddressChange={handleAddressChange} addressObject={addressObject}/>
                </Grid>

              
              ) : null}

              {isDelivery() ||
              isTakeaway(realTableId) ||
              isPickup(realTableId) ||
              isPickupOrDelivery(realTableId) ? (
                <OrderDateTime
                  pickupTimeTypeHandler={setPickupTimeType}
                  pickupTimeHandler={setPickupTime}
                  selectedDateHandler={setSelectedDate}
                />
              ) : null}

              {isMobileNumbeHidden() ? null : (
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    label={`Mobile Number (${
                      isDineMobileAndGuestNumberOptional() === true
                        ? "Optional"
                        : "required"
                    })`}
                    margin="none"
                    name="phone"
                    type="number"
                    inputProps={noWheelInputProps}
                    size="small"
                    error={isMobileNumberNotValid()}
                    helperText={phoneNumberError}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={phoneNumber}
                    onChange={(e) => updatePhoneNumber(e.target.value)}
                  />

                  {restaurant && restaurant.smsVerify === true ? (
                    <Box sx={{ marginTop: '6px' }}>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={sendVerifyCode}
                        disabled={checkLoading}
                        sx={{ textTransform: 'none', padding: '4px 12px', fontSize: '0.8125rem' }}
                      >
                        {checkLoading ? 'Sending...' : 'Send Code'}
                      </Button>
                      {checkLoading && (
                        <CircularProgress
                          size={14}
                          sx={{ marginLeft: '6px', verticalAlign: 'middle' }}
                        />
                      )}
                      <Typography variant="caption" display="block" color="textSecondary" sx={{ marginTop: '2px', fontSize: '0.7rem' }}>
                        SMS verification required
                      </Typography>
                    </Box>
                  ) : null}
                </Grid>
              )}

              {restaurant && restaurant.smsVerify === true ? (
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    label="Enter your code"
                    margin="none"
                    name="verifyCode"
                    type="number"
                    inputProps={noWheelInputProps}
                    size="small"
                    error={!checkNumber(verifyCode)}
                    helperText={verifyCodeError}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={verifyCode}
                    onChange={(e) => updateVerifyCode(e.target.value)}
                  />
                </Grid>
              ) : null}

              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth
                  label="Email (Optional, For receiving the order)"
                  margin="none"
                  name="email"
                  variant="outlined"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth
                  label={`Postcode (${
                    isPostcodeRequired() ? "Required" : "Optional"
                  })`}
                  margin="none"
                  name="postcode"
                  variant="outlined"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  helperText={
                    isPostcodeRequired() ? "Please enter a postcode" : ""
                  }
                  value={postcode}
                  onChange={(e) => setPostcode(e.target.value)}
                />
              </Grid>
              {restaurant &&
              restaurant.onlineSettings &&
              restaurant.onlineSettings.specialTerms &&
              restaurant.onlineSettings.specialTerms.length > 0 ? (
                <Grid item md={12} xs={12}>
                  <Alert severity="warning" sx={{ padding: '8px 16px' }}>
                    <Typography variant="body2">
                      <strong>{restaurant.onlineSettings.specialTerms}</strong>
                    </Typography>
                  </Alert>
                </Grid>
              ) : null}

              {isPaymentRequired() ||
              showTakeawayPayment() ||
              isQRCodePaymentNeed() ||
              showFoodcourtPayment() ||
              isDeliveryCashAvailable() ? (
                <Grid item md={6} xs={12}>
                  <Payments
                    restaurant={restaurant}
                    optional={isTakeaway(realTableId) || showFoodcourtPayment() || isQRCodePaymentOptional()}
                    allowDeliveryCash={isDeliveryCashAvailable()}
                  />
                </Grid>
              ) : null}

              {/* Order Summary Display */}
              {order.cart.length > 0 && (
                <Grid item md={12} xs={12}>
                  <Card className={classes.compactCard} elevation={2}>
                    <CardContent sx={{ padding: '12px !important', paddingBottom: '12px !important' }}>
                      <Typography variant="subtitle1" className={classes.sectionTitle}>
                        Order Summary
                      </Typography>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item xs={8}>
                          <Typography variant="body2">
                            Subtotal ({order.cart.reduce((count, curItem) => count + curItem.quantity, 0)} items)
                          </Typography>
                        </Grid>
                        <Grid item xs={4} style={{ textAlign: 'right' }}>
                          <Typography variant="h6" color="primary">
                            {getCurrencySymbol()}{order.cart.reduce((count, curItem) => count + curItem.quantity * curItem.subTotal, 0).toFixed(2)}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              )}

              {/* Delivery Fee and Service Fee Display */}
              {(getDeliveryFee() || getServiceFee(order.cart.reduce((count, curItem) => count + curItem.quantity * curItem.subTotal, 0), getDeliveryFee() ? parseFloat(getDeliveryFee().amount) : 0)) && (
                <Grid item md={12} xs={12}>
                  <Card className={classes.compactCard} elevation={2}>
                    <CardContent sx={{ padding: '12px !important', paddingBottom: '12px !important' }}>
                      <Typography variant="subtitle1" className={classes.sectionTitle}>
                        Delivery Information
                      </Typography>
                      {getDeliveryFee() && (
                        <Grid container spacing={1} alignItems="center" style={{ marginBottom: 8 }}>
                          <Grid item xs={8}>
                            <Typography variant="body2">
                              {getDeliveryFee().name}
                            </Typography>
                            {!isDeliveryTimeHidden() && (
                              <Typography variant="caption" color="textSecondary">
                                Est. delivery: {moment(getDeliveryFee().dropoffEta).format('DD/MM/YYYY HH:mm')}
                              </Typography>
                            )}
                          </Grid>
                          <Grid item xs={4} style={{ textAlign: 'right' }}>
                            <Typography variant="h6" color="primary">
                              {getCurrencySymbol()}{getDeliveryFee().amount}
                            </Typography>
                          </Grid>
                        </Grid>
                      )}
                      {getServiceFee(order.cart.reduce((count, curItem) => count + curItem.quantity * curItem.subTotal, 0), getDeliveryFee() ? parseFloat(getDeliveryFee().amount) : 0) && (
                        <Grid container spacing={1} alignItems="center">
                          <Grid item xs={8}>
                            <Typography variant="body2">
                              {getServiceFee(order.cart.reduce((count, curItem) => count + curItem.quantity * curItem.subTotal, 0), getDeliveryFee() ? parseFloat(getDeliveryFee().amount) : 0).name}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              {restaurant.deliveryServiceOnlineRate}% of order + delivery
                            </Typography>
                          </Grid>
                          <Grid item xs={4} style={{ textAlign: 'right' }}>
                            <Typography variant="h6" color="primary">
                              {getCurrencySymbol()}{getServiceFee(order.cart.reduce((count, curItem) => count + curItem.quantity * curItem.subTotal, 0), getDeliveryFee() ? parseFloat(getDeliveryFee().amount) : 0).amount}
                            </Typography>
                          </Grid>
                        </Grid>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              )}
            </Grid>
          </CardContent>
        </form>
      </Card>

      {turnstileSiteKey && (
        <Box sx={{ display: 'flex', justifyContent: 'center', padding: '12px 16px 0' }}>
          <Turnstile
            ref={turnstileRef}
            siteKey={turnstileSiteKey}
            onSuccess={setTurnstileToken}
            onExpire={() => setTurnstileToken(null)}
            onError={() => setTurnstileToken(null)}
          />
        </Box>
      )}

      <Box color="text.secondary" sx={{ padding: '8px 16px', paddingBottom: '100px' }}>
        <Typography variant="caption" display="block" sx={{ lineHeight: 1.4 }}>
          By placing this order you accept the{" "}
          <a href="/privacypolicy.html" target="_blank" rel="noopener noreferrer">
            Data Processing Policy
          </a>{" "}
          and{" "}
          <a href="/terms.html" target="_blank" rel="noopener noreferrer">
            Restaurant Terms of Service
          </a>.
          <br />
          This site is protected by Cloudflare Turnstile.
        </Typography>
      </Box>

      <Box className={classes.stickToBottom}>
        <Button
          size="large"
          variant="contained"
          fullWidth
          color="primary"
          onClick={placeOrder}
          disabled={
            buttonLoading ||
            isSubmittingRef.current ||
            (!isNameHidden() && !name) ||
            needCheckGuestNum() ||
            needCheckDateTime() ||
            needCheckAddress() ||
            isPostcodeRequired() ||
            isMobileNumberNotValid() ||
            needCheckPayment() ||
            order.cart.length === 0 ||
            !isVerifyCodeValid()
          }
          startIcon={<EmojiFoodBeverageIcon />}
          sx={{ 
            height: '56px',
            fontSize: '1rem',
            fontWeight: 600,
          }}
        >
          {paybuttonLabel()}
        </Button>
      </Box>
    </div>
  );
};

export default Checkout;
